module.exports = __webpack_public_path__ + "static/lakebed-80f88aa6ea71e316f59437bb15c94d0b.jpg";